import DefaultLayout from 'components/layout/DefaultLayout';
import ClientPerformanceAdminView from 'pages/performance/ClientPerformanceAdminView';
import PerformanceCreateDynamic from 'components/performance/PerformanceCreateDynamic';
import ClientPerformanceEntry from 'components/performance/ClientPerformanceEntry';
import PerformanceList from 'components/performance/PerformanceList';
import DynamicPerformancePage from 'pages/performance/DynamicPerformancePage';
import routes from 'common/routes';
import { roles } from 'common/constants/options';

const performanceRoutes = [
  // Admin and trainer routes

  {
    key: 'client-performance-admin',
    exact: true,
    path: routes.viewClientPerformance.path,
    component: ClientPerformanceAdminView,
    layout: DefaultLayout,
    allowedRoles: [roles.administrator, roles.trainer, roles.supervisor]
  },
  {
    key: 'performance-create-dynamic',
    exact: true,
    path: routes.createPerformanceDynamic.path,
    component: PerformanceCreateDynamic,
    layout: DefaultLayout,
    allowedRoles: [roles.administrator, roles.trainer]
  },
  {
    key: 'performance-list',
    exact: true,
    path: routes.listPerformance.path,
    component: PerformanceList,
    layout: DefaultLayout,
    allowedRoles: [roles.administrator, roles.trainer]
  },
  {
    key: 'dynamic-performance',
    exact: true,
    path: routes.dynamicPerformance.path,
    component: DynamicPerformancePage,
    layout: DefaultLayout,
    allowedRoles: [roles.administrator, roles.trainer]
  },

  // Client routes

  {
    key: 'performance-history',
    exact: true,
    path: routes.clientPerformances.path,
    component: ClientPerformanceEntry,
    layout: DefaultLayout,
    allowedRoles: [roles.client],
    requiresMembership: true
  }
];

export default performanceRoutes;
